/** @file Viewport panel registration: WebGL canvas, tools and gizmos (kept mounted while hidden). */
import type { PanelEntry } from '../panelEntry';
import { viewportTable } from './viewportTable';
import { ViewportPanel } from './ViewportPanel';

/** `always` keeps the WebGL context while the tab is hidden; bindings = viewport chords + tool chords. */
export const panel: PanelEntry = { id: 'viewport', title: 'panels.viewport.title', bindings: viewportTable(), component: ViewportPanel, renderer: 'always' };
